import React, { useEffect, useState } from 'react';
import AppShell from './components/AppShell';
import Container from "@material-ui/core/Container"
import {
  HashRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import JobApplications from "./routes/applications/JobApplications";
import CandidateDetail from './routes/candidates/CandidateDetail';
import Candidates from './routes/candidates/Candidates';
import Admin from "./routes/admin/Admin";
import Jobs from "./routes/jobs/Jobs";
import JobDetails from "./routes/jobs/JobDetails";
import DataPrivacy from "./routes/DataPrivacy";
import Interviews from "./routes/interviews/Interviews";

import { Auth } from "aws-amplify";
import { Authenticator, Button, Heading, useAuthenticator, useTheme, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import FastTrackQueue from './routes/FastTrackQueue';

function App() {

  // const [user, setUser] = useState<any | null>(null)

  // useEffect(() => {
    
  //   getUser().then((user: any) => {
  //     setUser(user);
  //   });

  // }, []);

  //   async function getUser() {
  //     try {
  //           const userData = await Auth.currentAuthenticatedUser();
  //           return userData;
  //       } catch (e) {

  //           return console.log('Not signed in');
  //       }
  //   }


  

  return (
    <Authenticator hideSignUp={true} variation="modal" >
      {({ signOut, user }) => (
        
        <Router>
          <AppShell user={user} signOut={signOut}>
            <Container maxWidth="xl">
              <Routes>
                <Route path="/interviews" element={<Interviews user={user} />}/>
                <Route path="/fasttrack-requests" element={<FastTrackQueue user={user} />}/>
                <Route path="/data-privacy" element={<DataPrivacy user={user} />}/>
                <Route path="/jobs/:jobRef" element={<JobDetails user={user} />}/>
                <Route path="/jobs" element={<Jobs user={user} />}/>
                <Route path="/admin" element={<Admin user={user} />}/>
                <Route path="/candidates/:candidateId" element={<CandidateDetail user={user} />}/>
                <Route path="/candidates" element={<Candidates/>} />
                <Route path="/" element={<JobApplications user={user} />}>
                  
                </Route>
              </Routes>
            </Container>
          </AppShell>
        </Router>
      )}
    </Authenticator>
    

  );
}

export default App;